/**
 * Asynchronously loads the component for ReportsInsight
 */
import Loadable from "react-loadable";

export default Loadable({
  loader: () => import("."),
  loading: () => null,
});
